import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./ViewOrderPage.module.css";
import MoreDropDown from "./MoreDropDown";
import Details from "./Components/Details/Details";
import Sidebar from "./Components/Sidebar/Sidebar";
import Tasks from "./Components/Tasks/Tasks";
import Files from "./Components/Files/Files";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
    </svg>
);

export default function ViewOrderPage() {
    const navigateTo = useNavigate();
    const [activeTab, setActiveTab] = useState("details");
    const [status, setStatus] = useState("Submitted");

    return (
        <div className={Classes.container}>
            <div className={Classes.header}>
                <button onClick={() => navigateTo("/orders")} className={Classes.backButton}>
                    <LeftArrow height='12px' fill='#969696' />
                    <h5>Orders</h5>
                </button>
            </div>

            <div className={Classes.hero} >
                <div className={Classes.heroLeft}>
                    <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                </div>
                <div className={Classes.heroRight} >
                    <div className="flexAlign10 mb-30" style={{ padding: '0 25px' }} >
                        <h3>Problem with the analytics</h3>
                    </div>

                    {activeTab === "details" && <Details />}
                    {activeTab === "tasks" && <Tasks />}
                    {activeTab === "files" && <Files />}

                </div>
            </div>

        </div>
    );
}